<template>
  <Section>
    <template #header>
      <div class="mr-auto">
        <strong class="black--text">Services you provide:</strong>
      </div>
      <ServicesDialog :offered="offered" @reload="reload"/>
    </template>

    <div 
      v-for="(category, i) in categories" :key="category"
      :class="{ 'mt-3': i > 0, 'mt-1': i === 0 }"
    >
      <div style="font-size: 14px; line-height: 20px">
        {{ category }}
      </div>
      <div class="d-flex flex-wrap mt-1" style="gap: 4px;">
        <v-chip 
          v-for="service in byCategory[category]"
          :key="service.service_id"
          x-small
          color="grey lighten-3" 
          class="px-2"
          style="border: 1px solid #C0C0C0 !important"
        >
          {{ service.service }}
        </v-chip>
      </div>
    </div>
    <div v-if="categories.length === 0" class="text-center pa-2 font-italic">
      No current services selected. Please click the pencil icon to add the services you offer!
    </div>
  </Section>
</template>

<script>
  import { Section } from '@/components/pages'
  import ServicesDialog from './ServicesDialog'

  import { mapActions, mapGetters } from 'vuex'

  export default {
    name: 'YouOfferedServices',

    props: ['pro'],

    components: { Section, ServicesDialog }, 

    computed: {
      ...mapGetters('services', ['offered']),

      categories() {
        return Object.keys(this.byCategory).sort()
      },

      byCategory() {
        let result = {}

        this.offered.forEach( service => {
          service.categories.forEach( category => {
            if (category.name in result) {
              result[category.name].push(service)
            } else {
              result[category.name] = [service]
            }
          })
        })

        return result
      },
    },

    methods: {
      ...mapActions('services', ['loadOffered']),

      reload() {
        this.loadOffered()
      },
    },

    created() {
      this.reload()
    }
  }
</script>
